var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.82 9c0 .61.5 1.1 1.12 1.1.3 0 .56.26.56.56v2.01a3.1 3.1 0 0 1-3.1 3.08H4.6a3.1 3.1 0 0 1-3.1-3.08v-2c0-.31.25-.56.56-.56.62 0 1.12-.5 1.12-1.1 0-.6-.48-1.05-1.12-1.05a.56.56 0 0 1-.56-.56V5.33a3.1 3.1 0 0 1 3.1-3.08h8.8a3.1 3.1 0 0 1 3.1 3.08v2a.56.56 0 0 1-.56.56c-.62 0-1.12.5-1.12 1.11Zm-4.13.49.88-.86c.16-.14.21-.36.14-.56a.55.55 0 0 0-.44-.37l-1.23-.18-.54-1.1a.55.55 0 0 0-1 0l-.54 1.1-1.22.18a.55.55 0 0 0-.45.37c-.07.2-.02.42.14.56l.88.86-.2 1.2c-.04.21.04.42.21.54a.56.56 0 0 0 .59.04L9 10.7l1.1.57c.18.1.4.09.58-.04a.54.54 0 0 0 .22-.54l-.21-1.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionmedium);
export default __webpack_public_path__ + "static/media/subscription.medium.231cab23eb97c23825ac3df3465551fb.svg";
export { ForwardRef as ReactComponent };